import { useNavigate } from 'react-router-dom';
import StarRating from '@/components/ui/StarRating';
import type { WineSummary } from '@/api/wines';

interface WineCardProps {
  wine: WineSummary;
  showRating?: boolean;
  quantity?: number;
  compact?: boolean;
}

export default function WineCard({ wine, showRating = false, quantity, compact = false }: WineCardProps) {
  const navigate = useNavigate();

  return (
    <div
      className={`wine-card ${compact ? 'wine-card-compact' : ''}`}
      onClick={() => navigate(`/wine/${wine.id}`)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && navigate(`/wine/${wine.id}`)}
    >
      <div className="wine-card-image">
        {wine.labelPhotoUrl ? (
          <img src={wine.labelPhotoUrl} alt={wine.name} loading="lazy" />
        ) : (
          <div className="wine-card-placeholder">
            <WinePlaceholderIcon style={wine.style} />
          </div>
        )}
      </div>

      <div className="wine-card-info">
        <p className="wine-card-producer">{wine.producer ?? ''}</p>
        <p className="wine-card-name">{wine.name}</p>
        {wine.vintage && <p className="wine-card-vintage">{wine.vintage}</p>}
        {quantity !== undefined && (
          <p className="wine-card-qty">×{quantity}</p>
        )}
        {showRating && wine.myRating && (
          <StarRating value={wine.myRating} readonly size="sm" />
        )}
      </div>
    </div>
  );
}

function WinePlaceholderIcon({ style }: { style?: string | null }) {
  const color =
    style === 'RED' ? '#8b1a2f'
    : style === 'WHITE' || style === 'SPARKLING' ? '#d4a855'
    : style === 'ROSE' ? '#e8747a'
    : '#999';

  return (
    <svg viewBox="0 0 40 80" fill="none" xmlns="http://www.w3.org/2000/svg" width={28}>
      <rect x="14" y="2" width="12" height="8" rx="2" fill={color} opacity={0.6} />
      <path d="M10 10 Q8 30 8 40 Q8 55 20 60 Q32 55 32 40 Q32 30 30 10 Z" fill={color} opacity={0.15} stroke={color} strokeWidth={1.5} />
      <path d="M10 10 Q8 30 8 40 Q8 55 20 60 Q32 55 32 40 Q32 30 30 10" fill="none" stroke={color} strokeWidth={1.5} />
    </svg>
  );
}
